<template>
  <div class="mt-8">
    <h2>Warehouse Performance</h2>
    <span>Warehouses with no completed appointments are not included</span>
    <insights-filter-bar
      include-layout-toggle
      @layoutChange="handleLayoutChange"
      @ready="ready = true"
      selection-persist-key="nova_insights_warehouse_1"
      @change="f => setFilters(f, 'warehouse')"></insights-filter-bar>
    <v-row class="mt-0 mb-8">
      <v-col :cols="filters.layout === 'grid' ? 6 : 12" class="mb-2">
        <warehouse-average-status-times-chart
          :key="renderKey"
          :date-range="filters.warehouse.dateRange"
          :show-all-time="filters.warehouse.showAllTime"
          v-if="ready"
          :selected-warehouse="filters.warehouse.selectedWarehouses">
        </warehouse-average-status-times-chart>
      </v-col>
      <v-col :cols="filters.layout === 'grid' ? 6 : 12" class="mb-2" v-if="!hideCapacityCharts">
        <warehouse-capacity-chart
          :key="renderKey"
          :date-range="filters.warehouse.dateRange"
          :show-all-time="filters.warehouse.showAllTime"
          v-if="ready"
          :selected-warehouse="filters.warehouse.selectedWarehouses"></warehouse-capacity-chart>
      </v-col>
    </v-row>
    <h2>Dock Performance</h2>
    <span>Docks with no completed appointments are not included</span>
    <v-row>
      <v-col :cols="filters.layout === 'grid' ? 6 : 12" class="pb-0">
        <insights-filter-bar
          :key="renderKey"
          selection-persist-key="nova_insights_warehouse_2"
          @ready="ready = true"
          include-dock-select
          @change="f => setFilters(f, 'dock')"></insights-filter-bar>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="filters.layout === 'grid' ? 6 : 12">
        <dock-capacity-chart
          :key="renderKey"
          :date-range="filters.dock.dateRange"
          :show-all-time="filters.dock.showAllTime"
          :selected-docks="filters.dock.selectedDocks"
          v-if="ready"
          :selected-warehouse="filters.dock.selectedWarehouses"></dock-capacity-chart>
      </v-col>
    </v-row>
    <h2 class="mt-15">Performance Breakdown</h2>
    <span>Detailed reporting on your warehouses, docks, and load types</span>
    <v-row class="mt-1">
      <v-col>
        <warehouse-metrics-table></warehouse-metrics-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import renderMixin from '@satellite/components/mixins/renderMixin';

export default {
  mixins: [renderMixin],
  data() {
    return {
      ready: false,
      filters: {
        warehouse: {},
        dock: {},
        layout: 'stacked'
      },
      hideCapacityCharts: true
    };
  },
  methods: {
    setFilters(filters, type) {
      this.filters[type] = filters;
    },
    handleLayoutChange(layout) {
      this.filters.layout = layout;
    }
  }
};
</script>
